let brandsMapping = {
  47: "https://beyondthebeach.com/collections/47",
  "Beyondthe Beach":
    "https://beyondthebeach.com/collections/vendors?q=Beyondthe%20Beach",
  Billabong: "https://beyondthebeach.com/collections/billabong",
  Bliz: "https://beyondthebeach.com/collections/bliz",
  Brooks: "https://beyondthebeach.com/collections/brooks",
  "DC Shoes": "https://beyondthebeach.com/collections/dc-shoes",
  Element: "https://beyondthebeach.com/collections/element",
  Hurley: "https://beyondthebeach.com/collections/hurley",
  Insta360: "https://beyondthebeach.com/collections/insta360",
  Kustom: "https://beyondthebeach.com/collections/kustom",
  "Liquid Force": "https://beyondthebeach.com/collections/liquid-force",
  "O'Neill": "https://beyondthebeach.com/collections/vendors?q=O%27Neill",
  Oakley: "https://beyondthebeach.com/collections/oakley",
  Quiksilver: "https://beyondthebeach.com/collections/quiksilver",
  "Ray-Ban": "https://beyondthebeach.com/collections/ray-ban",
  Reebok: "https://beyondthebeach.com/collections/reebok",
  "Rip Curl": "https://beyondthebeach.com/collections/rip-curl",
  Roxy: "https://beyondthebeach.com/collections/roxy",
  RVCA: "https://beyondthebeach.com/collections/vendors?q=RVCA",
  Seafolly: "https://beyondthebeach.com/collections/seafolly",
  "Segway-Ninebot": "https://beyondthebeach.com/collections/segway-ninebot",
  "Tommy Bahama": "https://beyondthebeach.com/collections/tommy-bahama",
  Vogue: "https://beyondthebeach.com/collections/vogue",
  VonZipper: "https://beyondthebeach.com/collections/vonzipper",
  Zoggs: "https://beyondthebeach.com/collections/vendors?q=Zoggs",
};
let varientMapper = {
  black: "#000",
  blue: "",
  white: "",
  green: "",
  grey: "",
  multicolor: "",
  beige: "",
  purple: "",
  brown: "",
  pink: "",
  red: "",
  orange: "",
  yellow: "",
  navy: "",
  gold: "",
  khaki: "",
  "canyon coral": "#E2A79A",
  clear: "",
  gray: "",
  "light sage": "#BCECAC",
  nat: "",
  silver: "",
  violet: "",
};
const availableSizeStrings = [
  "XXS",
  "2XS",
  "XS",
  "X Small",
  "S",
  "Small",
  "S/M",
  "M",
  "Medium",
  "M/L",
  "L",
  "Large",
  "L/XL",
  "XL",
  "X Large",
  "XXL",
  "2XL",
  "XXXL",
  "3XL",
  "0",
  "1",
  "2",
  "3",
  "3.5",
  "4",
  "4.5",
  "5",
  "5.5",
  "6",
  "6.5",
  "7",
  "7.0",
  "7.5",
  "8",
  "8.0",
  "8.5",
  "9",
  "9.0",
  "9.5",
  "10",
  "10.0",
  "10.5",
  "11",
  "11.0",
  "11.5",
  "12",
  "12.0",
  "12.5",
  "13",
  "14",
  "16",
  "18",
  "24",
  "26",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "38",
  "39",
  "40",
  "42",
  "44",
  "49",
  "52",
  "53",
  "57",
  "2X",
  "2X Large",
  "2X Small",
  "Large / X Large",
  "M3.5/W5",
  "M4/W5.5",
  "M4.5/W6",
  "M5/W6.5",
  "M5.5/W7",
  "M6/W7.5",
  "M6.5/W8",
  "M7/W8.5",
  "M7.5/W9",
  "M8/W9.5",
  "M8.5/W10",
  "M9/W10.5",
  "M9.5/W11",
  "M10/W11.5",
  "M10.5/W12",
  "M11/W12.5",
  "M11.5/W13",
  "M12/W13.5",
  "M13/W14.5",
  "One Size",
  "One SIze",
  "OS",
  "S-M",
  "Small / Medium",
];

const svgIcon = `
  <svg class="uae-dirham-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500" fill="currentColor" width="12" height="12" style="margin-right: 2px;">
    <path d="M474.94,1272.7H263.1a39.35,39.35,0,0,1-5-.1c-2.06-.28-3.18-1.34-1.43-3.29,30.93-34.3,40.49-76.77,46.14-120.72a396.09,396.09,0,0,0,2.84-49.77c.1-61.34,0-122.67.21-184,0-6.25-1.5-8.13-7.89-8-17.58.45-35.19.13-52.78.13-40.31,0-67-21-84.8-55.34-12-23.24-12-48.5-11.7-73.76,0-1.12-.22-2.59,1.23-3,1.65-.48,2.5,1,3.48,2,9,8.43,18.42,16.22,30.17,20.64a70.72,70.72,0,0,0,25,4.81c30,0,59.92-.12,89.87.13,5.54.05,7.4-1.3,7.34-7.13q-.42-44.92,0-89.86c.05-5.83-1.42-7.8-7.51-7.67-18.29.38-36.61.14-54.91.13-32.64,0-57-15.23-75-41.5-13.39-19.53-19.37-41.47-19.5-65.07,0-6.42-.17-12.84,0-19.25,0-2.16-1.54-5.44,1.28-6.25,2.06-.59,3.81,2.23,5.45,3.85,15.48,15.3,33.68,23.77,55.86,23.51,29.24-.34,58.49-.18,87.73,0,4.83,0,6.59-1.14,6.57-6.33-.31-65.37.28-130.75-.76-196.11-.71-44.65-8.34-88.23-28-129C271.89,251,265.14,241.34,257.92,232c-.82-1.07-2.76-1.71-2.19-3.26.71-1.91,2.76-1.4,4.39-1.4h8.56c127.91,0,255.82-.3,383.72.28,68.37.31,135.65,9.48,201.41,28.89,68,20.08,130,51.63,183.75,98.14,40.35,34.89,72.29,76.62,97,123.88a480.21,480.21,0,0,1,40.62,108.14c1.17,4.76,3.1,6.55,8.17,6.49,24-.24,48-.09,72,0,40.69.09,67.08,21.68,84.58,56.46,11.39,22.63,11.7,47.07,11.47,71.58,0,1.38.23,3.14-1.37,3.73-1.83.67-3-.82-4.16-2-8.21-8.33-17.39-15.22-28.3-19.73a67.66,67.66,0,0,0-25.65-5.26c-30.67-.12-61.34.08-92-.15-5.55,0-7.34,1.23-7,7.14a652.48,652.48,0,0,1,.07,89.75c-.48,6.85,1.8,7.87,7.79,7.75,17.11-.35,34.27.58,51.34-.24,46.19-2.24,80.8,30.71,93.43,70.73,6,19.15,5.81,38.77,5.64,58.45,0,1.13.51,2.59-1,3-1.92.54-3-1.18-4.15-2.25-8.74-8.43-18-16-29.58-20.36a66.74,66.74,0,0,0-23.55-4.75c-35.9-.07-71.8.06-107.7-.16-5.61,0-8,1.26-9.52,7.3-15.24,62.19-40.35,119.89-79.14,171.26s-87.42,91.1-144.44,120.61c-69.73,36.08-144.55,54.11-222.2,62.14-35,3.62-70.11,4.73-105.28,4.68q-74.9-.09-149.78,0ZM730.42,593.1V593q130.47,0,260.94.14c6.18,0,7.71-1.5,6.56-7.56-10.22-53.87-25.85-105.75-54.15-153.27-29.61-49.73-70.07-87.68-122-113.16C768.42,293,711.22,282.73,652.46,280.59c-60.56-2.22-121.18-.39-181.78-1-6.71-.07-8.21,1.89-8.19,8.33q.3,148.64,0,297.28c0,7,2.24,8.05,8.43,8Q600.66,592.95,730.42,593.1Zm.2,313.92V907q-130.15,0-260.3-.16c-6.38,0-7.83,1.7-7.82,7.93.21,95.32.12,190.63.22,286,0,6.31-2.84,14.49,1.35,18.46s12.26,1.26,18.6,1.17c60.34-.9,120.73,2.48,181-2.27,52-4.1,102.31-14.82,149.78-37,50.4-23.59,91.3-58.27,122.21-104.71,33-49.6,50.79-104.94,62.06-162.82,1.1-5.67-.69-6.6-6.1-6.59Q861.13,907.16,730.62,907Zm5.48-104.68v-.21c88.65,0,177.3-.09,265.95.19,6.38,0,8.23-1.78,8.36-7.71q1-44.91,0-89.8c-.13-5.47-1.76-7.17-7.47-7.16q-265.95.27-531.9,0c-7.12,0-8.6,2.25-8.52,8.88.34,28.75.17,57.51.16,86.26,0,9.54-.05,9.53,9.66,9.53Z" style="fill:currentColor"/>
  </svg>
`;

function modifyPriceStructure(tooltip) {
  return tooltip.innerHTML.replace(/^Dhs\.\s*/, svgIcon);
}

if (window.innerWidth < 768) {
  $("body").on("click", ".autocomplete-text-wrapper", function (e) {
    e.preventDefault();
    const searchTerm = $(this)
      .closest("a.autocomplete-link")
      .data("searchterm");
    $(".wizzy-search-input").val(searchTerm);
  });
}

const searchInput =
  window.innerWidth > 768
    ? document.querySelector(".custom-search-container .custom-search-input")
    : document.querySelector(
      ".custom-search-container-mobile .custom-search-input"
    );
if (searchInput) {
  searchInput.addEventListener("click", () => {
    setTimeout(() => {
      const wizzyAutocompleteWrapper = document.querySelector(
        ".wizzy-autocomplete-wrapper"
      );
      if (wizzyAutocompleteWrapper) {
        _swat.initializeActionButtons(".autocomplete-top-products");

        const swymTriggers = document.querySelectorAll(".swym-button");

        swymTriggers.forEach((button) => {
          button.addEventListener("click", function () {
            fetch("/?section_id=wishlist-count")
              .then((response) => response.text())
              .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");
                const countEl = doc.querySelector("#custom-wishlist-count");
                const scriptEl = doc.querySelector("script");

                if (countEl) {
                  // Replace existing DOM content
                  const target = document.getElementById(
                    "custom-wishlist-count"
                  );
                  if (target) target.replaceWith(countEl);

                  // Run the script manually
                  if (scriptEl) {
                    try {
                      eval(scriptEl.textContent); // 👈 Caution: use only in trusted contexts (like here)
                    } catch (e) {
                      console.error(
                        "Error executing wishlist-count script:",
                        e
                      );
                    }
                  } else {
                    console.warn("No script found in section");
                  }
                } else {
                  console.warn("custom-wishlist-count element not found");
                }
              })
              .catch((error) => {
                console.error("Error fetching wishlist count section:", error);
              });
          });
        });
      }
    }, 100);
  });
}

function findHaxCode(key) {
  return varientMapper[key] ? [varientMapper[key], true] : [key, false];
}

window.addEventListener("scroll", () => {
  const autocompleteWrapper = document.querySelector(
    ".wizzy-autocomplete-wrapper"
  );
  const searchInput = document.querySelector(".custom-search-input");
  if (autocompleteWrapper && searchInput) {
    if (window.innerWidth > 768) {
      tmp = window.scrollY == 0 ? "100px" : "55px";
    } else {
      tmp = window.scrollY == 0 ? "145px" : "110px";
    }
    autocompleteWrapper.style.top = tmp;
  }
});

const loadMoreBtn = document.querySelector(
  ".wizzy-pagination-list .pagination-arrow.next-arrow"
);
if (loadMoreBtn) {
  const loadMoreText = loadMoreBtn.querySelector(".text-mobile");

  loadMoreBtn.addEventListener("click", () => {
    if (loadMoreText) {
      loadMoreText.textContent = "Loading...";
    }
  });
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      console.log("before_lazy_init");
      window.wizzyConfig.search.configs.general.minQueryLength = 1;

      if (window.innerWidth < 768) {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: ".custom-search-container-mobile .custom-search-input",
          type: "search",
        };
      } else {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: ".custom-search-container .custom-search-input",
          type: "search",
        };
      }
      window.wizzyConfig.search.configs.pagination.appendInExistingList =
        "true";
      window.wizzyConfig.filters.configs.layout = "v1";
      window.wizzyConfig.common.isOnCategoryPage == true
        ? (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
          "#wizzy-shopify-collection-page-wrapper",
        ])
        : (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
          "body main",
        ]);
      // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers[0] =
      //   "body main";
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = "true";
      window.wizzyConfig.search.configs.facets.leftFacets.mobileCollapsible =
        "true";
      window.wizzyConfig.store.currency.symbol = "Dhs.";
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      console.log("before_init");
      window.wizzyConfig.search.configs.general.minQueryLength = 1;
      window.wizzyConfig.search.configs.pagination.appendInExistingList =
        "true";
      if (window.innerWidth < 768) {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: ".custom-search-container-mobile .custom-search-input",
          type: "search",
        };
      } else {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: ".custom-search-container .custom-search-input",
          type: "search",
        };
      }
      window.wizzyConfig.filters.configs.layout = "v1";
      window.wizzyConfig.common.isOnCategoryPage == true
        ? (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
          "#wizzy-shopify-collection-page-wrapper",
        ])
        : (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
          "body main",
        ]);
      // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers[0] =
      //   "body main";
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = "true";
      window.wizzyConfig.search.configs.facets.leftFacets.mobileCollapsible =
        "true";
      window.wizzyConfig.store.currency.symbol = "Dhs.";
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      payload.minQueryLength = 1;
      return payload;
    }
  );
  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER,
  //   function (payload) {
  //     console.log("BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER",payload);
  //     return payload;
  //   }
  // );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      try {
        
      // Check structure properly
      // if (data && data.payload && !data.isForDefault && !data.isForEmptyResult) {
      //   const query = data?.payload?.products?.filters?.q?.trim();
      //   // console.log("=====>>>",query);
      //   if (query) {
      //     Object.keys(data.payload).forEach(key => {
      //       var values = data.payload[key];
      //       // console.log("=====>>>",values);

      //       // Only process arrays
      //       if (Array.isArray(values)) {
      //         values.forEach(value => {
      //           if (value.value && typeof value.value === 'string') {
      //             const queryClean = query.replace(/\s+/g, ""); // remove spaces in query
      //             const flexibleQuery = queryClean.split("").map(ch => ch.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("[\\s-]*");
      //             // const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, "gi");
      //             const regex = new RegExp(`(${flexibleQuery})`, "gi");
      //             // console.log("=====>>>",regex);
      //             value.valueHighlighted = value.value.replace(regex, "<em>$1</em>");
      //           }
      //         });
      //       }
      //     });
      //   }
      // }
      
      } catch (error) {
        console.log(error);
      }
      console.log(data);
      return data;
    },1
  );
  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
  //   function (payload) {
  //     console.log("BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER",payload);
  //     return payload;
  //   }
  // );
  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_WRAPPER_RENDER,
  //   function (payload) {
  //     console.log("BEFORE_AUTOCOMPLETE_WRAPPER_RENDER",payload);
  //     return payload;
  //   }
  // );
  


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers[0] =
        "body main";
      payload.attributeFacetValuesLimit = 100;
      payload.minQueryLength = 1;

      const collectionPageBannerEle = document.querySelector(
        ".shopify-section--collection-banner"
      );
      if (collectionPageBannerEle) {
        collectionPageBannerEle.style.display = "none";
      }

      const body = document.querySelector("body");
      if(body && !body.classList.contains("search-page")) {
        body.classList.add("search-page");
      }

      const searchPageBreadcrumbEle = document.querySelector(".breadcrumbs-container");
      if (searchPageBreadcrumbEle) {
        searchPageBreadcrumbEle.style.setProperty(
          "display",
          "block",
          "important"
        );
      }

      const breadCrumbList = document.querySelector(".breadcrumbs-container .breadcrumbs .breadcrumbs__list");
      const breadCrumbSearchQuery = document.querySelector(".breadcrumbs-container .breadcrumbs .breadcrumbs__list .search-item .search-query");
      if (breadCrumbList && payload.q) {
        let existingItem = breadCrumbList.querySelector(".breadcrumbs__item.search-item");
        
        if (!existingItem) {
          const li = document.createElement("li");
          li.className = "breadcrumbs__item search-item";
          li.innerHTML = `/ <a class="breadcrumbs__link" href="${window.location.href}" aria-current="page">
              Search results for: <span class="search-query">${payload.q}</span>
            </a>`;
            breadCrumbList.appendChild(li);
        } else {
            const queryEl = existingItem.querySelector(".search-query");
            if (queryEl && queryEl.textContent !== payload.q) {
              queryEl.textContent = payload.q;
            }
        }
      }
      
      
      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTER_EXECUTED,
    function (payload) {
      payload.filters.attributeFacetValuesLimit = 100;
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      if (products) {
        products.forEach((product) => {
          // Initialize try-on properties
          product.tryOnBadge = false;
          product.tryOnKey = "";
          
          if (product.attributes) {
            product.attributes.forEach((attr) => {
              if (attr.id === "product_handle") {
                product.handle = attr.values[0].value[0];
              }
              if (attr.id === "product_brand_custom") {
                product.brand = attr.values[0].value[0];
                product.brandLink = brandsMapping[attr.values[0].value[0]];
              }
              if (attr.id === "product_tryon_key_custom") {
                product.tryOnBadge = true;
                product.tryOnKey = attr.values[0].value[0];
                console.log('Try-on product found:', product.handle, 'Key:', product.tryOnKey);
              }
            });
          }

          if(product.mainImage == "https://via.placeholder.com/360x360") {
            product.mainImage = "https://cdn.shopify.com/s/files/1/0933/9073/3586/files/default-1080x1000.png?v=1747392975";
          }
        });
      }
      return products;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      try {
        
        if (
          (payload.data.api === "search" || payload.data.api === "filter") &&
          payload.data.response.payload.total !== 0
        ) {
          // console.log(payload);
          if (window.innerWidth < 768) {
            var filterCloseBtnMobile = document.querySelector(
              ".wizzy-filters-overlay-close-btn"
            );
            var applyFilterBtnMobile = document.querySelector(
              ".wizzy-search-filters-left .wizzy-search-filters-left-wrapper .facets-drawer__floating-apply #wizzy-apply-filters-button"
            );
            var filterOverlay = document.querySelector(".wizzy-filters-bg");

            if (filterCloseBtnMobile && applyFilterBtnMobile) {
              filterCloseBtnMobile.addEventListener("click", function () {
                if (filterOverlay) {
                  filterOverlay.click();
                }
              });

              applyFilterBtnMobile.addEventListener("click", function () {
                if (filterOverlay) {
                  filterOverlay.click();
                }
              });
            }

            var sourceElement = document.querySelector(
              ".wizzy-search-sort-wrapper"
            );
            if (sourceElement) {
              var clonedContent = sourceElement.cloneNode(!0),
                targetDiv = document.querySelector(
                  ".wizzy-sort-wrapper-in-filter"
                );
              targetDiv &&
                !targetDiv.querySelector(".wizzy-search-sort-wrapper") &&
                targetDiv.appendChild(clonedContent);
            }

            var sortInFilter = document.querySelector(
              ".wizzy-search-filters-left-wrapper .wizzy-common-select-selector"
            );
            sortInFilter &&
              !sortInFilter.classList.contains("click-listener-attached") &&
              (sortInFilter.addEventListener("click", function (event) {
                event.preventDefault(), event.stopPropagation();
                var sortOptions = document.querySelector(
                  ".wizzy-sort-wrapper-in-filter .wizzy-common-select-options"
                );
                sortOptions &&
                  (sortOptions.style.display === "none" ||
                    sortOptions.style.display === ""
                    ? (sortOptions.style.display = "grid")
                    : (sortOptions.style.display = "none"));
              }),
                sortInFilter.classList.add("click-listener-attached"));
          }

          // code to show total number of products shown in total
          const productCountMessage = document.querySelector(
            ".wizzy-search-pagination .product-progress-container #product-count-message"
          );
          if (
            productCountMessage &&
            payload.data &&
            payload.data.response &&
            payload.data.response.payload
          ) {
            var viewedProducts = 0;
            if (
              payload.data.response.payload.pages ==
              payload.data.response.payload.filters.page
            ) {
              viewedProducts =
                (payload.data.response.payload.filters.page - 1) *
                payload.data.response.payload.filters.productsCount +
                payload.data.response.payload.result.length;
            } else {
              viewedProducts =
                payload.data.response.payload.filters.page *
                payload.data.response.payload.result.length;
            }
            const totalProucts = payload.data.response.payload.total;
            countMessage = `You've viewed ${viewedProducts} of ${totalProucts} products`;

            productCountMessage.innerHTML = countMessage;
          }

          //change Dhs. with svg inside price filter
          const labels = document.querySelectorAll(
            '[data-facetkey="sellingPrice"] .facet-item-label-value'
          ),
            minToolTip = document.querySelector(
              ".noUi-handle-lower .noUi-tooltip"
            ),
            maxToolTip = document.querySelector(
              ".noUi-handle-upper .noUi-tooltip"
            );
          minToolTip.innerHTML = modifyPriceStructure(minToolTip);
          maxToolTip.innerHTML = modifyPriceStructure(maxToolTip);

          //change symbol in selected filter
          const selectedPriceFilters = document.querySelectorAll(
            ".wizzy-selected-facet-list .wizzy-selected-facet-list-item[data-key='_sellingPrice'] .facet-item-label-value"
          );

          if (selectedPriceFilters) {
            selectedPriceFilters.forEach((selectedPriceFilter) => {
              console.log(minToolTip.innerHTML);
              selectedPriceFilter.innerHTML = `${minToolTip.innerHTML} - ${maxToolTip.innerHTML}`;
            });
          }
          
          const handleElement = document.querySelector(".noUi-handle");
          const observer2 = new MutationObserver(function (
            mutationsList,
            observer3
          ) {
            for (let mutation of mutationsList) {
              if (
                mutation.attributeName === "aria-valuemax" ||
                mutation.attributeName === "aria-valuemin"
              ) {
                const minToolTip2 = document.querySelector(
                  ".noUi-handle-lower .noUi-tooltip"
                );
                const maxToolTip2 = document.querySelector(
                  ".noUi-handle-upper .noUi-tooltip"
                );

                minToolTip2.innerHTML = modifyPriceStructure(minToolTip2);
                maxToolTip2.innerHTML = modifyPriceStructure(maxToolTip2);
              }
            }
          });
          const observerConfig = {
            attributes: true,
          };
          observer2.observe(handleElement, observerConfig);

          var slider = document.querySelector(".wizzy-facet-range-slider");
          if (slider) {
            var sliderInstance = slider.noUiSlider;
            sliderInstance.updateOptions({
              // margin: 10,
            });
          }

          //code to adjust selected price filter formate
          // const selectedPriceFilter = document.querySelector(
          //   ".wizzy-selected-facet-list .wizzy-selected-facet-list-item[data-facetkey='sellingPrice']"
          // );
          // if (selectedPriceFilter) {
          // }

          //code to add loading... text inside pagiantion button
          const loadMoreBtn = document.querySelector(
            ".wizzy-pagination-list .pagination-arrow.next-arrow"
          );
          if (loadMoreBtn) {
            const loadMoreText = loadMoreBtn.querySelector(".text-mobile");
            loadMoreBtn.addEventListener("click", () => {
              if (loadMoreText) {
                loadMoreText.textContent = "Loading...";
              }
            });
          }
        }

        if (payload.data.api === "search" || payload.data.api === "filter") {
          if (!payload.data.response.payload.filters.hasOwnProperty('sellingPrice')) {
            const minPriceInput = document.querySelector(".wizzy-range-input.wizzy-range-min");
            const maxPriceInput = document.querySelector(".wizzy-range-input.wizzy-range-max");
            if(minPriceInput && maxPriceInput) {
              minPriceInput.style.color = "gray";
              maxPriceInput.style.color = "gray";
            }
            console.log('Key exists');
          }
          _swat.initializeActionButtons(".wizzy-search-results");
        }
        if (
          payload.data.api === "autocomplete" ||
          (payload.data.api === "filter" &&
            payload.data.response.payload.filters.type ===
            "AUTOCOMPLETE_DEFAULT")
        ) {
          if (window.innerWidth > 768) {
            const searchInput = document.querySelector(
              ".custom-search-container .custom-search-input"
            );
            const wizzyAutocompleteWrapper = document.querySelector(
              ".wizzy-autocomplete-wrapper.withoutSuggestions"
            );
            if (wizzyAutocompleteWrapper) {
              const rect = searchInput.getBoundingClientRect();
              wizzyAutocompleteWrapper.style.setProperty(
                "left",
                `${rect.left + rect.width / 2}px`,
                "important"
              );
              wizzyAutocompleteWrapper.style.transform = "translateX(-45%)";
            }
          }

          _swat.initializeActionButtons(".autocomplete-top-products");
        }
      } catch (error) {
        console.log(error);
      }

      const swymTriggers = document.querySelectorAll(".swym-button");

      swymTriggers.forEach((button) => {
        button.addEventListener("click", function () {
          fetch("/?section_id=wishlist-count")
            .then((response) => response.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              const countEl = doc.querySelector("#custom-wishlist-count");
              const scriptEl = doc.querySelector("script");

              if (countEl) {
                // Replace existing DOM content
                const target = document.getElementById("custom-wishlist-count");
                if (target) target.replaceWith(countEl);

                // Run the script manually
                if (scriptEl) {
                  try {
                    eval(scriptEl.textContent); // 👈 Caution: use only in trusted contexts (like here)
                  } catch (e) {
                    console.error("Error executing wishlist-count script:", e);
                  }
                } else {
                  console.warn("No script found in section");
                }
              } else {
                console.warn("custom-wishlist-count element not found");
              }
            })
            .catch((error) => {
              console.error("Error fetching wishlist count section:", error);
            });
        });
      });

      if (window.wizzyConfig.common.isOnCategoryPage) {
        const collectionProductCountEle = document.querySelector(
          ".shopify-section--collection-banner .collection-product-count #filtered-product-count"
        );
        const searchPageBreadcrumbEle = document.querySelector(
          ".breadcrumbs-container"
        );
        if (collectionProductCountEle) {
          collectionProductCountEle.innerHTML =
            payload.data.response.payload.total + " Products";
        }

        if (searchPageBreadcrumbEle) {
          searchPageBreadcrumbEle.style.setProperty(
            "display",
            "none",
            "important"
          );
        }
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      try {
        if (payload.api === "search" || payload.api === "filter") {
          var facets = payload.response.payload.facets;
          facets.forEach((facet) => {
            if (facet.key === "colors") {
              facet.data.forEach((item) => {
                let [haxcode, isURLSwatch] = findHaxCode(
                  item.key.toLowerCase()
                );
                (item.isSwatch = true),
                  (item.isURLSwatch = isURLSwatch),
                  (item.isVisualSwatch = true),
                  (item.swatchValue = haxcode),
                  (item.data = {
                    value: item.key,
                    swatch: {
                      type: "visual",
                      value: haxcode,
                    },
                  });
              });
            } else if (facet.key === "product_Size") {
              let m = facet.data.length,
                newArray = [];
              for (let ii = 0; ii < availableSizeStrings.length; ii++) {
                for (let jj = 0; jj < m; jj++) {
                  if (facet.data[jj].key === availableSizeStrings[ii]) {
                    newArray.push(facet.data[jj]);
                  }
                }
              }
              facet.data = newArray;
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      if (window.innerWidth < 768) {
        var filterCloseBtnMobile = document.querySelector(
          ".wizzy-filters-overlay-close-btn"
        );
        var applyFilterBtnMobile = document.querySelector(
          ".wizzy-search-filters-left .wizzy-search-filters-left-wrapper .facets-drawer__floating-apply #wizzy-apply-filters-button"
        );
        var filterOverlay = document.querySelector(".wizzy-filters-bg");

        if (filterCloseBtnMobile && applyFilterBtnMobile) {
          filterCloseBtnMobile.addEventListener("click", function () {
            if (filterOverlay) {
              filterOverlay.click();
            }
          });

          applyFilterBtnMobile.addEventListener("click", function () {
            if (filterOverlay) {
              filterOverlay.click();
            }
          });
        }

        var sourceElement = document.querySelector(
          ".wizzy-search-sort-wrapper"
        );
        if (sourceElement) {
          var clonedContent = sourceElement.cloneNode(!0),
            targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");
          targetDiv &&
            !targetDiv.querySelector(".wizzy-search-sort-wrapper") &&
            targetDiv.appendChild(clonedContent);
        }

        var sortInFilter = document.querySelector(
          ".wizzy-search-filters-left-wrapper .wizzy-common-select-selector"
        );
        sortInFilter &&
          !sortInFilter.classList.contains("click-listener-attached") &&
          (sortInFilter.addEventListener("click", function (event) {
            event.preventDefault(), event.stopPropagation();
            var sortOptions = document.querySelector(
              ".wizzy-sort-wrapper-in-filter .wizzy-common-select-options"
            );
            sortOptions &&
              (sortOptions.style.display === "none" ||
                sortOptions.style.display === ""
                ? (sortOptions.style.display = "grid")
                : (sortOptions.style.display = "none"));
          }),
            sortInFilter.classList.add("click-listener-attached"));
      }

      // code to show total number of products shown in total
      const productCountMessage = document.querySelector(
        ".wizzy-search-pagination .product-progress-container #product-count-message"
      );
      if (
        productCountMessage &&
        payload.data &&
        payload.data.response &&
        payload.data.response.payload
      ) {
        const viewedProducts =
          payload.data.response.payload.filters.page *
          payload.data.response.payload.result.length;
        const totalProucts = payload.data.response.payload.total;
        countMessage = `Youve viewed ${viewedProducts} of ${totalProucts} products`;

        productCountMessage.innerHTML = countMessage;
      }
      return payload;
    }
  );
};
